// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3274":"cdb8bbd13f82e214","3888":"524144d7b2d32f49","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","5434":"9552fac1b5c4cf6e","8199":"f01407468f07465e"}[chunkId] + ".css";
};